import axios from 'axios';
import { API_CORE_URL_RELATIVE} from "../constantes/constantes";

const BASE_TICKER= "/api/core-clarosports/v2/ticker";

export async function getTickerLeaguesSelected() {

  let endpoint= `${API_CORE_URL_RELATIVE}${BASE_TICKER}/leagues/selected`;

  try {
    const { data, status } = await axios.get(endpoint, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    return { statusCode: status, data };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}

export async function getTickerLeaguesList() {

  let endpoint= `${API_CORE_URL_RELATIVE}${BASE_TICKER}/leagues`;

  try {
    const { data, status } = await axios.get(endpoint, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    return { statusCode: status, data };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}

export async function postTickerLeaguesSave(league_ids) {

  let endpoint= `${API_CORE_URL_RELATIVE}${BASE_TICKER}/leagues`;

  try {
    const { data, status } = await axios.post(endpoint, {
      league_ids
    }, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    return { statusCode: status, data };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}